// @ts-nocheck

export const localeCodes =  [
  "en-cy",
  "en-lt"
]
export const localeLoaders = {
  "en-cy": [
    {
      key: "locale_en_46json_eacbbfc2",
      load: () => import("#nuxt-i18n/eacbbfc2" /* webpackChunkName: "locale_en_46json_eacbbfc2" */),
      cache: true
    },
    {
      key: "locale_en_45cy_46json_3c920d7e",
      load: () => import("#nuxt-i18n/3c920d7e" /* webpackChunkName: "locale_en_45cy_46json_3c920d7e" */),
      cache: true
    }
  ],
  "en-lt": [
    {
      key: "locale_en_46json_eacbbfc2",
      load: () => import("#nuxt-i18n/eacbbfc2" /* webpackChunkName: "locale_en_46json_eacbbfc2" */),
      cache: true
    },
    {
      key: "locale_en_45lt_46json_532fbe43",
      load: () => import("#nuxt-i18n/532fbe43" /* webpackChunkName: "locale_en_45lt_46json_532fbe43" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/b52aae72" /* webpackChunkName: "config_i18n_46config_46ts_b52aae72" */)
]
export const normalizedLocales = [
  {
    code: "en-cy",
    iso: "en-cy",
    dir: "ltr",
    country: "cy",
    language: "en"
  },
  {
    code: "en-lt",
    iso: "en-lt",
    dir: "ltr",
    country: "lt",
    language: "en"
  }
]

